import ContentBlock from 'home/ContentBlock'
import TopBannerInContent from 'shared-components/ad/TopBannerInContent'
import { usePageBodyLayout } from 'shared-components/contexts/PageBodyContext'
import { useTaglessAd } from 'shared-components/hooks/use-tagless-ad'
import styleUtils from 'shared-components/styles/util.module.css'
import Disclaimer from 'shared-components/ui/Disclaimer'
import type { DSHomePage } from 'shared-definitions/types'
import type { DSContentBlockAA } from 'types.aa.ds'
import styles from './HomeTemplate.module.css'

type LayoutItem =
  | { variant: 'ad'; type: PlaywireTaggedType }
  | { variant: 'grid'; items: DSContentBlockAA[] }

function mixComponentBlocks(items: readonly DSContentBlockAA[]): LayoutItem[] {
  const layout: LayoutItem[] = [
    {
      variant: 'grid',
      items: items.slice(0, 5),
    },
    {
      variant: 'ad',
      type: 'leaderboard_btf',
    },
  ]

  const restBlocks = items.slice(5)
  for (let i = 0; i < restBlocks.length; i += 4) {
    const subItems = restBlocks.slice(i, i + 4)
    layout.push({
      variant: 'grid',
      items: subItems,
    })

    // do not place ad after lists with articles
    if (restBlocks.length > i + 3) {
      layout.push({
        variant: 'ad',
        type: 'leaderboard_btf',
      })
    }
  }
  return layout
}

interface HomeTemplateProps {
  page: DSHomePage<DSContentBlockAA>
}

const HomeTemplate: React.VFC<HomeTemplateProps> = ({ page }) => {
  useTaglessAd(['bottom_rail'])

  const layout = mixComponentBlocks(page.blocks)

  return (
    <div ref={usePageBodyLayout()} className={styleUtils.wrapper}>
      <Disclaimer />
      {layout.map((part, partIndex) => {
        if (part.variant === 'ad') {
          return (
            <div key={partIndex} className={styles.leaderboard}>
              <TopBannerInContent className={styleUtils.mobileFull} />
            </div>
          )
        }

        return (
          <div className={styles.grid} key={partIndex}>
            {part.items.map((item, index) => (
              <ContentBlock key={index} index={index} data={item} tpl="home" />
            ))}
          </div>
        )
      })}
    </div>
  )
}

export default HomeTemplate
